import { Schema } from '@blade/std-lib'

export class XEmbedResizePostMessage extends Schema.Class<XEmbedResizePostMessage>(
  'XEmbedResizePostMessage',
)({
  'twttr.embed': Schema.Struct({
    method: Schema.Literal('twttr.private.resize'),
    params: Schema.NonEmptyArray(
      Schema.Struct({
        data: Schema.Struct({
          tweet_id: Schema.String,
        }),
        height: Schema.Number,
        width: Schema.Number,
      }),
    ),
  }),
}) {
  static decode = Schema.decodeUnknownOption(XEmbedResizePostMessage)
}
